import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { ConfirmDialog } from "security-app/components/common/Modal";
import List from "./List";
const UsersModal = ({
  closeModal,
  confirmDisabled,
  isLoading = false,
  onConfirm,
  owner = void 0,
  show = false
}) => {
  const [ownerId, setOwnerId] = useState(owner);
  const _onConfirm = useCallback(() => onConfirm(ownerId), [onConfirm, ownerId]);
  useEffect(() => {
    setOwnerId(owner);
  }, [show]);
  const assignText = ownerId ? "Assign new owner" : "Remove owner";
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show,
      onConfirm: _onConfirm,
      confirmDisabled,
      isLoading,
      confirmText: assignText,
      onCancel: closeModal,
      title: "Select an Event Owner"
    },
    /* @__PURE__ */ React.createElement(List, { ownerId, setOwnerId })
  );
};
export default UsersModal;
